// extracted by mini-css-extract-plugin
module.exports = {"loginFacebook":"FacebookLogin_loginFacebook__2-Ado"};